import { useTranslation } from "react-i18next";
import CountryCode from "components/select/countryCode";
import Select from "components/select";
import { IResvInf } from "interface/mypage";
import Button from "components/button/default";
import { mailOption } from "util/option";
import { MouseEvent, useEffect, useRef } from "react";
import { alertControl, successControl } from "util/commAction";
import { useMutation } from "@tanstack/react-query";
import Input from "components/updateForm/input";
import { useLocation, useOutletContext } from "react-router-dom";
import { IOutletContext } from "../layout";
import { updateResvInfApi } from "components/api/mypage";
import "./inf.scss";

type IProps = {
  resvInf: IResvInf | any;
};

export default function RmInf({ resvInf }: IProps) {
  const { t } = useTranslation();
  const { resvStat } = useOutletContext<IOutletContext>();
  const formRef = useRef<HTMLFormElement>(null);

  const { pathname } = useLocation();

  //예약자 정보 수정
  const infUpdateMutation = useMutation({
    mutationFn: updateResvInfApi,
    onSuccess: (res) => {
      if (res) {
        successControl({
          status: res.status,
          success: () => {
            alertControl({
              isOpen: true,
              inner: t("alr_bk_update_uinf"),
            });
          },
        });
      }
    },
  });
  const handleUpdate = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    let params = {};
    const inputs = formRef.current?.querySelectorAll(
      'input[data-type="U"]'
    ) as NodeListOf<HTMLInputElement>;
    const text = formRef.current?.querySelector(
      'textarea[data-type="U"]'
    ) as HTMLTextAreaElement;

    if (text) {
      params = {
        ...params,
        [text.name]: text.value,
      };
    }

    inputs.forEach((input) => {
      const name = input.name;
      const value = input.value;

      params = {
        ...params,
        [name]: value,
      };
    });

    if (!Object.values(params).some((value) => !!value)) {
      return alertControl({
        isOpen: true,
        inner: t("alr_bk_update_prev"),
      });
    }

    alertControl({
      isOpen: true,
      inner: t("alr_bk_update"),
      cncl_btn: true,
      click: () => {
        infUpdateMutation.mutate({
          ...params,
          rmResvNo: resvInf.rmResvNo,
        });
      },
    });
  };

  //초기 세팅
  useEffect(() => {
    const inputs = formRef.current?.querySelectorAll(
      "input"
    ) as NodeListOf<HTMLInputElement>;
    inputs.forEach((input) => {
      input.setAttribute("data-type", "C");
    });
    const text = formRef.current?.querySelector(
      "textarea"
    ) as HTMLTextAreaElement;
    if (text) {
      text.setAttribute("data-type", "C");
    }
  }, []);

  return (
    <div className="bk-rm-inf">
      {!pathname.includes("sample") && (
        <>
          <h3 className="sub">{t("sb_ttl_rm_inf_mpg")}</h3>
          <ul className="mb-[2.5rem] flex flex-col gap-3">
            <li className="flex">
              <h5 className="">{t("txt_rm_typ_cmm")}</h5>
              <h5>{resvInf?.rmTypNm}</h5>
            </li>
            <li className="flex">
              <h5 className="">{t("txt_gst_nm_cmm")}</h5>
              <h5 className="flex gap-1 ">
                <span>
                  {t("txt_adlt_bk")}
                  {resvInf?.adltPerCt}
                </span>
                <span>/</span>
                <span>
                  {t("txt_chld_bk")}
                  {resvInf?.chldPerCt}
                </span>
              </h5>
            </li>
            <li className="flex">
              <h5 className=""> {t("txt_op_cmm")}</h5>
              <h5>{t("txt_nan_bk")}</h5>
            </li>
            <li className="flex">
              <h5 className="">{t("txt_fr_prd_cmm")}</h5>

              {/* 무료취소 기간 */}
              {/* <h5>{fullDateFormat(resvInf.)}</h5> */}
            </li>
          </ul>
        </>
      )}
      <h3 className="sub">{t("btn_inf_mdf_mpg")}</h3>
      {/* <h4 className="text-blue-300 mb-6">{resvInf?.rmTypNm}</h4> */}
      <form className="" ref={formRef}>
        <fieldset disabled={resvStat !== "wait"}>
          <ul className="flex flex-col gap-6">
            <li>
              <label htmlFor="dot">{t("lbl_bk_nm_cmm")}</label>
              <div className="flex gap-2">
                <Input name={"cstSurnm"} defaultValue={resvInf?.resvCstSurnm} />
                <Input name={"cstFstnm"} defaultValue={resvInf?.resvCstFstnm} />
              </div>
            </li>
            <li>
              <label htmlFor="dot">{t("lbl_ph_nm_cmm")}</label>
              <div className="flex gap-2">
                <CountryCode
                  styles="flex-1"
                  option={resvInf?.resvCstMblCntyCd}
                  name="cstMblCntyCd"
                />
                <Input
                  name={"cstMblNo"}
                  styles="flex-1"
                  defaultValue={resvInf?.resvCstMblNo}
                />
              </div>
            </li>
            <li>
              <label htmlFor="dot">{t("lbl_eml_bk")}</label>
              <div className="flex flex-col md:flex-row start-center gap-2 ">
                <div className="w-full md:w-auto">
                  <Input
                    name={"eml_1"}
                    styles="flex-1"
                    defaultValue={resvInf?.resvCstEml.split("@")[0]}
                  />
                </div>
                <div className="w-full start-center gap-2">
                  <span>@</span>
                  <Input
                    name={"eml_2"}
                    defaultValue={resvInf?.resvCstEml.split("@")[1]}
                    styles="flex-1 md:w-full"
                  />
                  <Select
                    list={mailOption}
                    styles=""
                    defaultValue={undefined}
                    name={"eml_3"}
                  />
                </div>
              </div>
            </li>
            <li>
              <label htmlFor="">{t("lbl_rqst_bk")}</label>
              <textarea
                name="reqCn"
                id=""
                defaultValue={resvInf?.reqCn}
                onClick={(e) => {
                  e.currentTarget.setAttribute("data-type", "U");
                }}
              />
            </li>
          </ul>

          {/* 투숙완료 및 예약 취소 시 HIDDEN */}
          {resvStat === "wait" && (
            <div className="flex justify-end mt-6">
              <Button
                text={t("btn_inf_mdf_mpg")}
                styels="radius-4 w-[170px] h-48"
                onClick={handleUpdate}
              />
            </div>
          )}
        </fieldset>
      </form>
    </div>
  );
}
